import React from 'react';

type Props = {color?: string};

export const HomeTabSvg: React.FC<Props> = ({color = '#FF8A71'}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={50} height={24} fill='none'>
    <path
      fill={color}
      d='M25 6.5 16 14v7h5v-5h8v5h5v-7L25 6.5Z'
    />
    <path
      fill={color}
      fillRule='evenodd'
      d='M25 4.5 14 13.3V22h7v-5h8v5h7V13.3L25 4.5Zm0 2.4 9 7.2V20h-3v-5h-12v5h-3v-5.9l9-7.2Z'
      clipRule='evenodd'
    />
  </svg>
);
